import { Component, OnInit } from '@angular/core';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { AuthService } from '../shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../login/services/login.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [{ provide: CarouselConfig, useValue: { interval: 7500, noPause: false, showIndicators: true } }],
})
export class ForgotPasswordComponent implements OnInit {
  public slides: Array<{ [key: string]: string }>;
  public email: string;
  private emailRegex: RegExp;
  public showError: boolean;

  constructor(
    private authService: AuthService,
    private _toastrService: ToastrService,
    private _router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService
  ) {
    this.emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    this.slides = [{ image: '/assets/img/login/bg.jpg', text: 'First Slide' }];
  }
  ngOnInit(): void {
    this.loginService.setPrivateToken(this.route.snapshot.data.user.token);
  }

  private _isEmailValid(): boolean {
    return this.emailRegex.test(this.email);
  }

  sendResetPasswordEmail(): void {
    const isEmailValid = this._isEmailValid();
    if (!isEmailValid) {
      this.showError = true;
      return;
    }
    this.showError = false;
    this.authService.resetPassword(this.email).subscribe({
      next: res => {
        this.loginService.credentials.email = this.email;
        this._router.navigate(['update-password']);
        this._toastrService.success('A reset password has been sent to your email.', 'Authentication');
      },
      error: error => {
        console.error(error);
        this._toastrService.error('This email does not belong to any user.', 'Authentication');
      },
    });
  }
}
